import React from 'react';
import IdentifyForm from '../components/IdentifyForm';
import IdentifyFormBook from '../components/IdentifyBook';
import Navigation from '../components/Navigation';
import { useParams } from "react-router-dom";

function IdentifyBook(){
    const { next } = useParams();

    return (
        <div className="App">
            <Navigation />
            <div className="container">
                <IdentifyFormBook next={next}/>
                {/* <IdentifyForm next={next}/> */}
            </div>
        </div>
    )
}

export default IdentifyBook;